import { useTranslation } from "react-i18next";
import { Badge } from "../../../components/ui/badge/index.js";
import { Button } from "../../../components/ui/button/index.js";
import { TechnicalValue } from "../TechnicalValue.js";
import type { PendingWhatsAppRegistrationMode } from "../whatsapp-setup-presentation.js";

export function WhatsAppPendingResume({
  mode,
  displayPhoneNumber,
  busy,
  disabled,
  onComplete,
  onCancel,
}: {
  mode: PendingWhatsAppRegistrationMode;
  displayPhoneNumber: string | null;
  busy: boolean;
  disabled: boolean;
  onComplete: () => void;
  onCancel: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <section
      className="grid w-full max-w-md gap-4 rounded-xl border border-line bg-surface px-5 py-5 text-start shadow-sm"
      data-testid="whatsapp-pending-card"
      data-pending-mode={mode}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="m-0 text-[0.9375rem] font-semibold text-ink">
          {t("whatsapp.pending.awaitingTitle")}
        </h2>
        <Badge variant="warning">{t("whatsapp.pending.awaitingBadge")}</Badge>
      </div>
      {displayPhoneNumber ? (
        <TechnicalValue className="w-fit text-[1.15rem] font-semibold tabular-nums text-ink">
          {displayPhoneNumber}
        </TechnicalValue>
      ) : null}
      <p
        className="m-0 text-[0.8125rem] leading-relaxed text-muted"
        data-testid="whatsapp-pending-explanation"
      >
        {mode === "complete"
          ? t("whatsapp.pending.resumeMessage")
          : t("whatsapp.pending.notRecoverable")}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {mode === "complete" ? (
          <Button
            type="button"
            variant="default"
            className="flex-1"
            onClick={onComplete}
            disabled={busy || disabled}
            data-testid="whatsapp-complete-registration"
          >
            {t("whatsapp.phoneManagement.completeRegistration")}
          </Button>
        ) : null}
        <Button
          type="button"
          variant="outline"
          className={mode === "complete" ? undefined : "flex-1 sm:flex-none"}
          onClick={onCancel}
          disabled={busy}
          data-testid="whatsapp-cancel-pending"
        >
          {t("whatsapp.pending.cancel")}
        </Button>
      </div>
    </section>
  );
}
